import React, { useState, useEffect } from 'react';
import { Button, Dialog, Box, makeStyles, Grid, DialogTitle, DialogContent } from '@material-ui/core';
import GridContainer from '../../../../../@jumbo/components/GridContainer';
import Field from '../../../../../@jumbo/components/custom/Field';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
  num: {
    display: 'block',
    width: '100%',
  },
  date: {
    display: 'block',
    width: '100%',
    color: 'grey',
    fontWeight: 100,
    fontSize: 'small',
  },
  type: {
    display: 'block',
    width: '100%',
    color: 'grey',
    fontWeight: 100,
    fontSize: 'small',
  },
}));

const defaultReclamo = {
  num: '',
  fechaIngreso: '',
  tipo: '',
  reclamante: '',
  Rut: '',
  Etapa: '',
  materia: '',
  via: '',
  region: '',
  comuna: '',
};

const VerReclamo = ({ openDialog = false, close, reclamo = defaultReclamo }) => {
  const classes = addStyle();
  const [num, setNum] = useState('');
  const [fecha, setFecha] = useState(false);
  const [tipo, setTipo] = useState(false);
  const [nombreCompleto, setNombreCompleto] = useState(false);
  const [rut, setRut] = useState(false);
  const [materia, setMateria] = useState(false);
  const [via, setVia] = useState(false);
  const [region, setRegion] = useState(false);
  const [comuna, setComuna] = useState(false);

  useEffect(() => {
    if (reclamo) {
      setNum(reclamo.n_reclamo ? reclamo.n_reclamo : 'nulo');
      setFecha(reclamo.fechaIngreso ? reclamo.fechaIngreso : 'nulo');
      setTipo(reclamo.tipo ? reclamo.tipo : 'nulo');
      setNombreCompleto(reclamo.nombre_rec ? reclamo.nombre_rec : 'nulo');
      setRut(reclamo.run_pac ? reclamo.run_pac : 'nulo');
      setMateria(reclamo.materia ? reclamo.materia : 'nulo');
      setVia(reclamo.via ? reclamo.via : 'nulo');
      setRegion(reclamo.region ? reclamo.region : 'nulo');
      setComuna(reclamo.comuna ? reclamo.comuna : 'nulo');
    }
  }, [reclamo]);

  const onCloseDialog = event => {
    close();
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <DialogTitle className={classes.dialogTitleRoot}>
        <label className={classes.num}> Reclamo N° {num} </label>
        <label className={classes.date}> Fecha Ingreso: {fecha} </label>
        <label className={classes.type}> Tipo: {tipo} </label>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          <GridContainer>
            <Grid item xs={12} sm={6}>
              <Field label="Nombre Reclamante" value={nombreCompleto} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field label="Rut" value={rut} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field label="Materia" value={materia} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field label="Via Tramitación" value={via} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field label="Región" value={region} />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field label="Comuna" value={comuna} />
            </Grid>
          </GridContainer>
        </Box>
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={onCloseDialog}>&nbsp;Cerrar&nbsp;</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default VerReclamo;
